module.exports = __webpack_public_path__ + "static/img/whatisnew-flow-1-1-desktop.ebddfea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/whatisnew/whatisnew-flow-1-1-desktop.png
// module id = Gclr
// module chunks = 4